import {Component, OnInit} from "@angular/core";
import {GebaeudeStepComponent} from "./gebaeude.step.component";

@Component({
    selector: 'app-stancheck-gebaeude-ergebnis',
    templateUrl: './gebaeude.ergebnis.component.html',
    standalone: false
})
export class GebaeudeErgebnisComponent extends GebaeudeStepComponent implements OnInit {
  ngOnInit() {
    super.ngOnInit();
  }
}
